import type { ReactNode } from "react";

import { useWakeLock } from "react-screen-wake-lock";

import { WakeLockContext } from "./WakeLockContext";

export function WakeLockProvider({ children }: { children: ReactNode }) {
  const wakeLock = useWakeLock();

  return <WakeLockContext.Provider value={wakeLock}>{children}</WakeLockContext.Provider>;
}
